(() => {
  window.__vexProductPersonalizationFallback = true;

  const blockSelector = 'product-personalization';
  const oldInputSelector = '[data-personalization-input]';

  function getForm(block) {
    return document.getElementById(block.dataset.productFormId) || document.querySelector('form[action*="/cart/add"]');
  }

  function showDynamicCheckout(block) {
    const form = getForm(block);

    if (!form) return;

    form.querySelectorAll('.shopify-payment-button, shopify-accelerated-checkout, .shopify-payment-button__button').forEach((button) => {
      const holder = button.closest('.product__submit__item') || button;

      holder.hidden = false;
      holder.setAttribute('aria-hidden', 'false');
      holder.style.display = '';
    });
  }

  function restoreBlock(block) {
    if (!block) return;

    block.removeAttribute('data-service-variant-id');
    block.removeAttribute('data-price-addition');
    block.dataset.serviceVariantId = '';
    block.dataset.priceAddition = '';
    block.serviceVariantId = '';
    block.priceAddition = 0;
    block.isAdding = false;

    const price = block.querySelector('.product-personalization__price');
    if (price) price.textContent = 'Free';

    const input = block.querySelector(oldInputSelector) || block.querySelector('.product-personalization__input');
    if (input) {
      // Keep the name/form attributes so Shopify submits this as a normal line item property.
      input.removeAttribute('data-personalization-input');
    }

    showDynamicCheckout(block);

    block.shouldHandlePersonalization = () => false;
    block.handleFormSubmit = () => false;
    block.handleCartAddEvent = () => false;
    block.handleAddButtonClick = () => false;
    block.submitPersonalizedCart = () => false;
    block.addPersonalizedItems = () => false;
    block.addCartFormData = () => Promise.reject(new Error('Personalization service add-on disabled.'));
    block.updateDisplayedPrices = () => {};
    block.toggleDynamicCheckout = () => showDynamicCheckout(block);
    block.handleInputChange = () => {
      showDynamicCheckout(block);
      if (typeof block.validateInput === 'function') block.validateInput();
    };
  }

  function restorePersonalizationBlocks() {
    document.querySelectorAll(blockSelector).forEach(restoreBlock);
  }

  restorePersonalizationBlocks();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restorePersonalizationBlocks, { once: true });
  }

  document.addEventListener('shopify:section:load', restorePersonalizationBlocks);

  new MutationObserver(restorePersonalizationBlocks).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
